/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TransferTermsRouteImport } from './routes/transfer-terms'
import { Route as TransferStatusRouteImport } from './routes/transfer-status'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PoaRenewRouteImport } from './routes/poa-renew'
import { Route as PensionOverviewRouteImport } from './routes/pension-overview'
import { Route as PensionForecastRouteImport } from './routes/pension-forecast'
import { Route as OpenSignPolicyRouteImport } from './routes/open-sign-policy'
import { Route as MyDocumentsRouteImport } from './routes/my-documents'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppWebviewRouteImport } from './routes/app-webview'
import { Route as AdviceSummaryRouteImport } from './routes/advice-summary'
import { Route as IndexRouteImport } from './routes/index'
import { Route as HomeIndexRouteImport } from './routes/home/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as InsuranceIdentifierTransactionsRouteImport } from './routes/$insuranceIdentifier/transactions'
import { Route as InsuranceIdentifierInformationRouteImport } from './routes/$insuranceIdentifier/information'
import { Route as InsuranceIdentifierHoldingsRouteImport } from './routes/$insuranceIdentifier/holdings'

const TransferTermsRoute = TransferTermsRouteImport.update({
  id: '/transfer-terms',
  path: '/transfer-terms',
  getParentRoute: () => rootRouteImport,
} as any)
const TransferStatusRoute = TransferStatusRouteImport.update({
  id: '/transfer-status',
  path: '/transfer-status',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PoaRenewRoute = PoaRenewRouteImport.update({
  id: '/poa-renew',
  path: '/poa-renew',
  getParentRoute: () => rootRouteImport,
} as any)
const PensionOverviewRoute = PensionOverviewRouteImport.update({
  id: '/pension-overview',
  path: '/pension-overview',
  getParentRoute: () => rootRouteImport,
} as any)
const PensionForecastRoute = PensionForecastRouteImport.update({
  id: '/pension-forecast',
  path: '/pension-forecast',
  getParentRoute: () => rootRouteImport,
} as any)
const OpenSignPolicyRoute = OpenSignPolicyRouteImport.update({
  id: '/open-sign-policy',
  path: '/open-sign-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const MyDocumentsRoute = MyDocumentsRouteImport.update({
  id: '/my-documents',
  path: '/my-documents',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppWebviewRoute = AppWebviewRouteImport.update({
  id: '/app-webview',
  path: '/app-webview',
  getParentRoute: () => rootRouteImport,
} as any)
const AdviceSummaryRoute = AdviceSummaryRouteImport.update({
  id: '/advice-summary',
  path: '/advice-summary',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeIndexRoute = HomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const InsuranceIdentifierTransactionsRoute =
  InsuranceIdentifierTransactionsRouteImport.update({
    id: '/$insuranceIdentifier/transactions',
    path: '/$insuranceIdentifier/transactions',
    getParentRoute: () => rootRouteImport,
  } as any)
const InsuranceIdentifierInformationRoute =
  InsuranceIdentifierInformationRouteImport.update({
    id: '/$insuranceIdentifier/information',
    path: '/$insuranceIdentifier/information',
    getParentRoute: () => rootRouteImport,
  } as any)
const InsuranceIdentifierHoldingsRoute =
  InsuranceIdentifierHoldingsRouteImport.update({
    id: '/$insuranceIdentifier/holdings',
    path: '/$insuranceIdentifier/holdings',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/advice-summary': typeof AdviceSummaryRoute
  '/app-webview': typeof AppWebviewRoute
  '/login': typeof LoginRoute
  '/my-documents': typeof MyDocumentsRoute
  '/open-sign-policy': typeof OpenSignPolicyRoute
  '/pension-forecast': typeof PensionForecastRoute
  '/pension-overview': typeof PensionOverviewRoute
  '/poa-renew': typeof PoaRenewRoute
  '/profile': typeof ProfileRoute
  '/signup': typeof SignupRoute
  '/transfer-status': typeof TransferStatusRoute
  '/transfer-terms': typeof TransferTermsRoute
  '/$insuranceIdentifier/holdings': typeof InsuranceIdentifierHoldingsRoute
  '/$insuranceIdentifier/information': typeof InsuranceIdentifierInformationRoute
  '/$insuranceIdentifier/transactions': typeof InsuranceIdentifierTransactionsRoute
  '/dashboard': typeof DashboardIndexRoute
  '/home': typeof HomeIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/advice-summary': typeof AdviceSummaryRoute
  '/app-webview': typeof AppWebviewRoute
  '/login': typeof LoginRoute
  '/my-documents': typeof MyDocumentsRoute
  '/open-sign-policy': typeof OpenSignPolicyRoute
  '/pension-forecast': typeof PensionForecastRoute
  '/pension-overview': typeof PensionOverviewRoute
  '/poa-renew': typeof PoaRenewRoute
  '/profile': typeof ProfileRoute
  '/signup': typeof SignupRoute
  '/transfer-status': typeof TransferStatusRoute
  '/transfer-terms': typeof TransferTermsRoute
  '/$insuranceIdentifier/holdings': typeof InsuranceIdentifierHoldingsRoute
  '/$insuranceIdentifier/information': typeof InsuranceIdentifierInformationRoute
  '/$insuranceIdentifier/transactions': typeof InsuranceIdentifierTransactionsRoute
  '/dashboard': typeof DashboardIndexRoute
  '/home': typeof HomeIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/advice-summary': typeof AdviceSummaryRoute
  '/app-webview': typeof AppWebviewRoute
  '/login': typeof LoginRoute
  '/my-documents': typeof MyDocumentsRoute
  '/open-sign-policy': typeof OpenSignPolicyRoute
  '/pension-forecast': typeof PensionForecastRoute
  '/pension-overview': typeof PensionOverviewRoute
  '/poa-renew': typeof PoaRenewRoute
  '/profile': typeof ProfileRoute
  '/signup': typeof SignupRoute
  '/transfer-status': typeof TransferStatusRoute
  '/transfer-terms': typeof TransferTermsRoute
  '/$insuranceIdentifier/holdings': typeof InsuranceIdentifierHoldingsRoute
  '/$insuranceIdentifier/information': typeof InsuranceIdentifierInformationRoute
  '/$insuranceIdentifier/transactions': typeof InsuranceIdentifierTransactionsRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/home/': typeof HomeIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/advice-summary'
    | '/app-webview'
    | '/login'
    | '/my-documents'
    | '/open-sign-policy'
    | '/pension-forecast'
    | '/pension-overview'
    | '/poa-renew'
    | '/profile'
    | '/signup'
    | '/transfer-status'
    | '/transfer-terms'
    | '/$insuranceIdentifier/holdings'
    | '/$insuranceIdentifier/information'
    | '/$insuranceIdentifier/transactions'
    | '/dashboard'
    | '/home'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/advice-summary'
    | '/app-webview'
    | '/login'
    | '/my-documents'
    | '/open-sign-policy'
    | '/pension-forecast'
    | '/pension-overview'
    | '/poa-renew'
    | '/profile'
    | '/signup'
    | '/transfer-status'
    | '/transfer-terms'
    | '/$insuranceIdentifier/holdings'
    | '/$insuranceIdentifier/information'
    | '/$insuranceIdentifier/transactions'
    | '/dashboard'
    | '/home'
  id:
    | '__root__'
    | '/'
    | '/advice-summary'
    | '/app-webview'
    | '/login'
    | '/my-documents'
    | '/open-sign-policy'
    | '/pension-forecast'
    | '/pension-overview'
    | '/poa-renew'
    | '/profile'
    | '/signup'
    | '/transfer-status'
    | '/transfer-terms'
    | '/$insuranceIdentifier/holdings'
    | '/$insuranceIdentifier/information'
    | '/$insuranceIdentifier/transactions'
    | '/dashboard/'
    | '/home/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdviceSummaryRoute: typeof AdviceSummaryRoute
  AppWebviewRoute: typeof AppWebviewRoute
  LoginRoute: typeof LoginRoute
  MyDocumentsRoute: typeof MyDocumentsRoute
  OpenSignPolicyRoute: typeof OpenSignPolicyRoute
  PensionForecastRoute: typeof PensionForecastRoute
  PensionOverviewRoute: typeof PensionOverviewRoute
  PoaRenewRoute: typeof PoaRenewRoute
  ProfileRoute: typeof ProfileRoute
  SignupRoute: typeof SignupRoute
  TransferStatusRoute: typeof TransferStatusRoute
  TransferTermsRoute: typeof TransferTermsRoute
  InsuranceIdentifierHoldingsRoute: typeof InsuranceIdentifierHoldingsRoute
  InsuranceIdentifierInformationRoute: typeof InsuranceIdentifierInformationRoute
  InsuranceIdentifierTransactionsRoute: typeof InsuranceIdentifierTransactionsRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  HomeIndexRoute: typeof HomeIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/transfer-terms': {
      id: '/transfer-terms'
      path: '/transfer-terms'
      fullPath: '/transfer-terms'
      preLoaderRoute: typeof TransferTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transfer-status': {
      id: '/transfer-status'
      path: '/transfer-status'
      fullPath: '/transfer-status'
      preLoaderRoute: typeof TransferStatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/poa-renew': {
      id: '/poa-renew'
      path: '/poa-renew'
      fullPath: '/poa-renew'
      preLoaderRoute: typeof PoaRenewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pension-overview': {
      id: '/pension-overview'
      path: '/pension-overview'
      fullPath: '/pension-overview'
      preLoaderRoute: typeof PensionOverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pension-forecast': {
      id: '/pension-forecast'
      path: '/pension-forecast'
      fullPath: '/pension-forecast'
      preLoaderRoute: typeof PensionForecastRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/open-sign-policy': {
      id: '/open-sign-policy'
      path: '/open-sign-policy'
      fullPath: '/open-sign-policy'
      preLoaderRoute: typeof OpenSignPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-documents': {
      id: '/my-documents'
      path: '/my-documents'
      fullPath: '/my-documents'
      preLoaderRoute: typeof MyDocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app-webview': {
      id: '/app-webview'
      path: '/app-webview'
      fullPath: '/app-webview'
      preLoaderRoute: typeof AppWebviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/advice-summary': {
      id: '/advice-summary'
      path: '/advice-summary'
      fullPath: '/advice-summary'
      preLoaderRoute: typeof AdviceSummaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home/': {
      id: '/home/'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$insuranceIdentifier/transactions': {
      id: '/$insuranceIdentifier/transactions'
      path: '/$insuranceIdentifier/transactions'
      fullPath: '/$insuranceIdentifier/transactions'
      preLoaderRoute: typeof InsuranceIdentifierTransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$insuranceIdentifier/information': {
      id: '/$insuranceIdentifier/information'
      path: '/$insuranceIdentifier/information'
      fullPath: '/$insuranceIdentifier/information'
      preLoaderRoute: typeof InsuranceIdentifierInformationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$insuranceIdentifier/holdings': {
      id: '/$insuranceIdentifier/holdings'
      path: '/$insuranceIdentifier/holdings'
      fullPath: '/$insuranceIdentifier/holdings'
      preLoaderRoute: typeof InsuranceIdentifierHoldingsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdviceSummaryRoute: AdviceSummaryRoute,
  AppWebviewRoute: AppWebviewRoute,
  LoginRoute: LoginRoute,
  MyDocumentsRoute: MyDocumentsRoute,
  OpenSignPolicyRoute: OpenSignPolicyRoute,
  PensionForecastRoute: PensionForecastRoute,
  PensionOverviewRoute: PensionOverviewRoute,
  PoaRenewRoute: PoaRenewRoute,
  ProfileRoute: ProfileRoute,
  SignupRoute: SignupRoute,
  TransferStatusRoute: TransferStatusRoute,
  TransferTermsRoute: TransferTermsRoute,
  InsuranceIdentifierHoldingsRoute: InsuranceIdentifierHoldingsRoute,
  InsuranceIdentifierInformationRoute: InsuranceIdentifierInformationRoute,
  InsuranceIdentifierTransactionsRoute: InsuranceIdentifierTransactionsRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  HomeIndexRoute: HomeIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
